import React from 'react'
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material'

const TeamStatistics = ({ stage }) => {
  // Агрегируем данные по секторам
  const aggregatedData = (stage || []).reduce((acc, item) => {
    if (!item.sector || !item.teamName) return acc

    const existingSector = acc.find((s) => s.sector === item.sector)
    const validFish = item.fishList?.filter((fish) => fish.weight > 0) || []

    if (existingSector) {
      // Обновляем существующий сектор
      existingSector.fishCount += validFish.length
      existingSector.totalWeight += Number(item.totalWeight) || 0
      existingSector.weighings += 1
    } else {
      // Добавляем новый сектор
      acc.push({
        sector: item.sector,
        teamName: item.teamName,
        fishCount: validFish.length,
        totalWeight: Number(item.totalWeight) || 0,
        weighings: 1,
        lastUpdated: item.time,
      })
    }
    return acc
  }, [])

  // Сортируем по секторам
  const sortedData = [...aggregatedData].sort((a, b) => {
    // Извлекаем числа из строки, если они есть
    const extractNumber = (str) => {
      const match = String(str).match(/\d+/)
      return match ? parseInt(match[0], 10) : Infinity
    }

    const numA = extractNumber(a.sector)
    const numB = extractNumber(b.sector)

    // Если числа найдены в обоих случаях
    if (numA !== Infinity && numB !== Infinity) {
      return numA - numB
    }

    // Иначе сортируем как строки
    return String(a.sector).localeCompare(String(b.sector))
  })

  if (sortedData.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">Нет данных для отображения</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 2 }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>
                <strong>Сектор</strong>
              </TableCell>
              <TableCell>
                <strong>Команда</strong>
              </TableCell>

              <TableCell align="right">
                <strong>Количество рыб</strong>
              </TableCell>
              <TableCell align="right">
                <strong>Общий вес (г)</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Последнее обновление</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item, index) => (
              <TableRow key={`${item.sector}-${index}`}>
                <TableCell>{item.sector}</TableCell>
                <TableCell>{item.teamName}</TableCell>
                <TableCell align="right">{item.fishCount}</TableCell>
                <TableCell align="right">{item.totalWeight}</TableCell>
                <TableCell align="center">
                  {new Date(item.lastUpdated).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.secondary">
          Всего секторов: {sortedData.length}
        </Typography>
      </Box>
    </Box>
  )
}

export default TeamStatistics
